<script>
const createDefaultForm = () => ({
  latitude: -6.2,
  longitude: 106.816666,
  status: 'Preparing',
  wo_number: '',
  plan_datetime: '',
  is_plan_confirmed: false,
  customer: '',
  city: '',
  technician_qty: 0,
  estimated_time: '',
  dt_number: '',
  created_by: '',
})

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'create',
    },
    item: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    createdBy: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      form: createDefaultForm(),
      statusOptions: [
        'Preparing',
        'To Schedule',
        'Scheduled',
        'Confirmed Technician',
        'Install',
        'Completed',
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.mode === 'edit' ? 'Edit WO Plan' : 'Create WO Plan'
    }
  },
  watch: {
    value(visible) {
      if (visible) this.setForm()
    },
    item: {
      deep: true,
      handler() {
        if (this.value) this.setForm()
      },
    },
  },
  methods: {
    setForm() {
      const source = this.item || {}
      const form = {
        ...createDefaultForm(),
        ...source,
      }

      form.plan_datetime = this.toDateTimeLocal(form.plan_datetime)
      form.estimated_time = this.toDateTimeLocal(form.estimated_time)
      form.created_by = form.created_by || this.createdBy || ''
      form.is_plan_confirmed = Boolean(form.is_plan_confirmed)

      this.form = form
    },
    toDateTimeLocal(value) {
      if (!value) return ''

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''

      const offset = date.getTimezoneOffset() * 60000
      return new Date(date.getTime() - offset).toISOString().slice(0, 16)
    },
    toIsoDate(value) {
      if (!value) return ''

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''

      return date.toISOString()
    },
    close() {
      this.$emit('input', false)
    },
    submit() {
      if (!this.form.wo_number || !this.form.customer || !this.form.status || !this.form.plan_datetime) {
        this.$toast.warning('Please complete required fields')
        return
      }

      const payload = {
        latitude: Number(this.form.latitude),
        longitude: Number(this.form.longitude),
        status: this.form.status,
        wo_number: this.form.wo_number,
        plan_datetime: this.toIsoDate(this.form.plan_datetime),
        is_plan_confirmed: Boolean(this.form.is_plan_confirmed),
        customer: this.form.customer,
        city: this.form.city,
        technician_qty: Number(this.form.technician_qty),
        dt_number: this.form.dt_number,
        created_by: Number(this.form.created_by),
      }

      if (this.form.estimated_time) {
        payload.estimated_time = this.toIsoDate(this.form.estimated_time)
      }

      this.$emit('submit', payload)
    },
  },
}
</script>

<template>
  <b-modal
    :visible="value"
    :title="modalTitle"
    size="lg"
    hide-footer
    @hide="close"
  >
    <b-form @submit.prevent="submit">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label">WO Number <span class="text-danger">*</span></label>
          <b-form-input v-model="form.wo_number" required />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Status <span class="text-danger">*</span></label>
          <b-form-select v-model="form.status" :options="statusOptions" required />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Customer <span class="text-danger">*</span></label>
          <b-form-input v-model="form.customer" required />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">City</label>
          <b-form-input v-model="form.city" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">DT Number</label>
          <b-form-input v-model="form.dt_number" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Technician Qty</label>
          <b-form-input v-model="form.technician_qty" type="number" min="0" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Plan Date <span class="text-danger">*</span></label>
          <b-form-input v-model="form.plan_datetime" type="datetime-local" required />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Estimated Time</label>
          <b-form-input v-model="form.estimated_time" type="datetime-local" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Latitude</label>
          <b-form-input v-model="form.latitude" type="number" step="any" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Longitude</label>
          <b-form-input v-model="form.longitude" type="number" step="any" />
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label">Created By</label>
          <b-form-input v-model="form.created_by" type="number" />
        </div>
        <div class="col-md-6 mb-3 d-flex align-items-end">
          <b-form-checkbox v-model="form.is_plan_confirmed">
            Plan Confirmed
          </b-form-checkbox>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="me-2" :disabled="loading" @click="close">
          Cancel
        </b-button>
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner v-if="loading" small class="me-1" />
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
